import type { ReactNode } from "react";
import { ArrowLeft } from "lucide-react";
import { cn } from "@/lib/cn";

interface Props {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  className?: string;
  onBack?: () => void;
  backAriaLabel?: string;
}

export function PageHeader({
  title,
  subtitle,
  actions,
  className,
  onBack,
  backAriaLabel = "Go back",
}: Props) {
  return (
    <header className={cn("flex items-center justify-between gap-4 px-6 pt-3 pb-2", className)}>
      <div className="flex items-start gap-3 min-w-0">
        {onBack ? (
          <button
            type="button"
            onClick={onBack}
            aria-label={backAriaLabel}
            className="mt-0.5 p-2 -ml-2 rounded-md text-bridge-muted hover:text-bridge-fg hover:bg-bridge-surface/80 transition-colors focus-ring shrink-0"
          >
            <ArrowLeft size={20} />
          </button>
        ) : null}
        <div className="min-w-0 animate-riseIn motion-reduce:animate-none">
          <h1 className="text-lg font-semibold text-bridge-fg tracking-tight">{title}</h1>
          {subtitle && <p className="mt-1 text-sm text-bridge-muted">{subtitle}</p>}
        </div>
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0 animate-riseIn motion-reduce:animate-none [animation-delay:120ms]">{actions}</div>}
    </header>
  );
}